import initialize from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-documents/actions/initialize.js';
import upload from '@gov.wa.lni/application.warehouse-retaliation/source/components/lni-retaliation-documents/actions/upload.js';

export default {
    initialize,
    upload,
};